import { z } from 'zod';
/**
 * ClientMeeting — a meeting booked with a prospect following a call.
 *
 * Lifecycle (backend invariants):
 *   scheduled → confirmed → completed (terminal) | no_show (terminal)
 *             → cancelled (terminal, can skip confirmed)
 *
 * create() on the backend rejects a meetingDate in the past (with a 60s
 * clock-skew tolerance).
 */
export const MeetingStatusSchema = z.enum([
    'scheduled',
    'confirmed',
    'cancelled',
    'completed',
    'no_show',
]);
export const AntiNoShowConfigSchema = z.object({
    emailConfirm: z.boolean(),
    smsConfirm: z.boolean(),
    calendarInvite: z.boolean(),
    emailReminderDay: z.boolean(),
    smsReminderDay: z.boolean(),
    emailReminderHour: z.boolean(),
    smsReminderHour: z.boolean(),
    emailReminder30min: z.boolean(),
});
export const ClientMeetingSchema = z.object({
    id: z.string(),
    clientEmail: z.string().email(),
    agentEmail: z.string().email(),
    prospectName: z.string().min(1),
    prospectEmail: z.string().default(''),
    prospectPhone: z.string().default(''),
    prospectCompany: z.string().default(''),
    meetingDate: z.coerce.date(),
    meetingTime: z.string(),
    durationMinutes: z.number().int().positive(),
    notes: z.string().default(''),
    antiNoShowConfig: AntiNoShowConfigSchema,
    status: MeetingStatusSchema.default('scheduled'),
    remindersSent: z.array(z.string()).default([]),
    createdDate: z.coerce.date(),
    updatedDate: z.coerce.date(),
});
//# sourceMappingURL=meeting.schema.js.map